import { msalInstanceB2C } from "../authConfig";
import {
  flushStorage,
  setAuthToken,
  setAuthType,
  setExpiresOn,
} from "./storage";

export const UnauthorizedUserLogout = (
  setAuth,
  isAuthorized,
  dispatch, // Pass dispatch from a component
  errorMessage = "Unauthorized access"
) => {
  // Dispatch error toast if unauthorized
  if (typeof setAuth === "function") {
    setAuth(""); // Clear authentication state
  }
  // Clear local storage/auth tokens
  setAuthToken("");
  setExpiresOn("");
  // Check if MSAL instance is available before logging out
  if (msalInstanceB2C) {
    msalInstanceB2C.logoutPopup({
      postLogoutRedirectUri: "/", // Redirects after logout
    });
  } else {
    console.warn("MSAL instance not found. Logout may not be complete.");
  }
  setAuthType("");
  flushStorage();
  setTimeout(() => {
    if (!isAuthorized && dispatch) {
      // dispatch(showToast({ message: errorMessage, variant: "error" }));
      alert(errorMessage); // Replace with your toast implementation
    }
  }, 1000); // Delay for 1 second before showing the toast
};
